module.exports = __webpack_public_path__ + "img/4664.6c4ab2f8.jpg";